<nav class="navbar navbar-light ms-2 bg-light navbar-expand-lg ">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">        
        <div class="form-inline col-2 me-2">
            <input id="busquedaFormControl" type="text" class="form-control" placeholder="Buscar por nombre, teléfono o email"
                [formControl]="buscadorFormControl" (input)="filtrarContactos()"/>
        </div>
        <button class="btn btn-primary ms-2" type="button" [disabled]="cargandoLista"
            (click)="abrirModal()">Agregar nuevo contacto</button>
    </div>
</nav>

<div class="row">  
    <div class="col col-3">
        <div class="list-group py-3 menu-izq">
            <div class="col col-md-12" *ngIf="cargandoLista">
                <div class="spinner-container" >
                    <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd
                        Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
                        <p style="color: white">C a r g a n d o . . . </p>
                    </ngx-spinner>
                </div>
            </div>
            <!-- lista de aeroplantas -->
            <div *ngIf="!cargandoLista">
                <div *ngFor="let c of contactosFiltrados; let i=index">
                    <button type="button" class="list-group-item list-group-item-action" (click)="usuarioSeleccionoContacto(i)">
                    <div class="d-flex w-100 justify-content-between">
                        <p >{{ c.nombre }} </p>
                    </div>
                    </button>
                </div>
            </div>        
        </div>
    </div>
    <!-- informacion de las lineas aereas -->
    <div class="col col-9 py-3">
            <div *ngIf="contactoSeleccionado != null" id="tablaInformacion">
                <app-contactos-detalle 
                [contactoSeleccionado]="contactoSeleccionado" 
                (recargarListaDeContactos)="ngOnInit()">
              </app-contactos-detalle>
            </div>
    </div>
</div>

<ng-template #content let-modal>
    <app-contactos-detalle (recargarListaDeContactos)="ngOnInit()"></app-contactos-detalle>
</ng-template>